// extracted by mini-css-extract-plugin
export default {"testimonial":"TestimonialCard_testimonial__K1De6"};